import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'Test Name',
    value: 'testName',
  },
  /*  {
    label: 'Display name',
    value: 'displayName',
  }, */
  {
    label: 'Parameter',
    value: 'parameter',
  },
  {
    label: 'Standard',
    value: 'standard',
  },
  {
    label: 'Minimum',
    value: 'minimum',
  },
  {
    label: 'Maximum',
    value: 'maximum',
  },
  {
    label: 'Target',
    value: 'targetValue',
  },
  /*  {
    label: 'Applicable SKUs',
    value: 'itemName',
  }, */
  {
    action: ['edit', 'delete'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
